module.exports = "/static/assets/9e6fa02c90bda1a6681d729d805de953.png";